<template>
  <div style="background: #f9f9f9">
    <div class="soluBanner" v-if="bannerUrl">
      <img :src="bannerUrl" alt="" />
    </div>
    <div class="dynamic_title flex">
      <div
        :class="index == indexNum ? 'dynamic_title_one_active' : ''"
        class="dynamic_title_one flex"
        v-for="(items, index) in titleList"
        :key="index"
        @click="chooseChindrenMenu(index)"
      >
        <div>
          <p>{{ items.title }}</p>
          <i v-if="index == indexNum" class="dynamic_xinei"></i>
        </div>

        <i class="dynamic_xi"></i>
      </div>
    </div>
    <div class="flex dynamic_input" id="detailsBody">
      <div class="dynamic_input_two flex">
        <input
          type="text"
          placeholder="输入关键词"
          v-model="searchText"
          @change="searchParkInfo"
        />
        <i class="iconfont">&#xe6a8;</i>
      </div>
    </div>
	<div v-if="dynamicList.length == 0"  class="dynamic_box2" >
	      <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
	  </div>
    <div class="dynamic_box flex" v-else>
      <div
        class="dynamic_box_list"
        v-for="(items, index) in dynamicList"
        :key="index"
        @click="getDynamicBox(items.uuid)"
      >
        <div class="dynamic_list_img">
          <img :src="items.pictureUrl" alt="" />
        </div>
        <div class="dynamic_list_text">
          <h4>{{ items.title }}</h4>
          <p class="dynamic_list_mess">
            {{ items.summary }}
          </p>
          <div class="dynamic_list_bottom flex">
            <p>{{ items.publishDate.substring(0, 10) }}</p>
            <p>{{ items.publishDate.substring(10) }}</p>
            <p class="flex" style="align-items: center">
              <i class="iconfont">&#xe611;</i>
              <span>{{ items.pageViews }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="new_bottom_empty"></div>
      <div class="new_bottom_empty"></div>
      <div class="new_bottom_empty"></div>
      <div class="new_bottom_empty"></div>
    </div>
    <!-- 分页 -->
    <div class="pageina">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getParkList,
  getNewsItemList,
  getProgramChildList,
  getBannerInfo,
} from "../../utils/interface";
import { mapState } from "vuex";

export default {
  //   解决方案
  name: "solution",
  components: {},
  data() {
    return {
      indexNum: 0,
      showAllStatus: true,
      uuid: "",
      parkName: "",
      searchText: "",
      programUuid: "",
      // 分页
      current: 0,
      pageSize: 10,
      total: 0,
      soluTabsIndex: "0",
      // 列表
      bannerUrl: '',
      dynamicList: [],
      parkList: [],
      value: "",
      parentCode: "YQDT",
      titleList: [],
      setIn: null,
    };
  },
  created() {
    document.documentElement.scrollTop = 0;
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getParkNewsBanner();
        this.getProgramChildList();
        if (this.$route.params.uuid != undefined) {
          this.uuid = this.$route.params.uuid;
          this.value = this.uuid;
          this.getParkList();
          this.getNewsItemList();
        } else {
          this.getParkList();
          this.getNewsItemList();
        }
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    getParkNewsBanner() {
      getBannerInfo("PARK_NEWS_BANNER").then((res) => {
        // if (res.length !== 0) {
        this.bannerUrl = res.value;
        // this.imgLoad();
        // }
      });
    },
    getProgramChildList() {
      getProgramChildList({ parentCode: this.parentCode }).then((res) => {
        this.titleList = res;
        console.log('sdff', this.titleList);
        this.titleList.unshift({ title: "全部", uuid: "" });
      });
    },
    getParkList() {
      let params = {
        parkName: this.parkName,
        current: 0,
        pageSize: 100,
      };
      getParkList(params).then((res) => {
        if (res.success) {
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let parkInfo = {};
              parkInfo.value = res.data[i].uuid;
              parkInfo.label = res.data[i].parkName;
              this.parkList.push(parkInfo);
            }
          }
        }
      });
    },
    getNewsItemList() {
      let params = {
        origin: "PARK",
        status: "PUBLISH",
        current: this.current,
        pageSize: this.pageSize,
        title: this.searchText,
        programUuid: this.programUuid,
      };
      getNewsItemList(params).then((res) => {
        if (res.success) {
          this.total = res.total;
          this.dynamicList = res.data;
        }
      });
    },
    searchParkInfo() {
      this.current = 1;
      this.getNewsItemList();
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getNewsItemList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.current = val;
      this.getNewsItemList();
      let top = document.getElementById("detailsBody").offsetTop - 200;
      document.documentElement.scrollTop = top;
    },
    getDynamicBox(uuid) {
      // this.$router.push({ name: "parkDetails", params: { uuid: uuid } });
	  let routeData = this.$router.resolve({
	    name: "parkDetails",
	    params: { uuid:uuid},
	  });
	  window.open(routeData.href, "_blank");
    },
    chooseChindrenMenu(index) {
      this.indexNum = index;
      let info = this.titleList[index];
      this.programUuid = info.uuid;
      this.getNewsItemList();
      /*if (index == "z") {
        this.showAllStatus = true;
        this.indexNum = 0;
      } else {
        this.showAllStatus = false;
        this.indexNum = index;
      }*/
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #009999;
}
.soluBanner {
  position: relative;
  width: 100%;
  img {
    width: 100%;
  }
  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }
    .soluBanText {
      margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }
      p:nth-child(2) {
        font-size: 9px;
      }
    }
    button {
      border: 1px solid #fff;
      border-radius: 30px;
      color: #fff;
      background: none;
      padding: 2px 5px;
    }
  }
}
.pageina {
  padding: 74px 0;
  text-align: center;
}
.dynamic_title {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #efefef;
  font-size: 14px;
  align-items: center;
  margin-bottom: 20px;
  .dynamic_title_one_active {
    color: #009999 !important;

    align-items: flex-end !important;
    height: 32px !important;
  }
  .dynamic_title_one {
    // color: #009999;
    cursor: pointer;
    color: #777;
    font-size: 16px;
    text-align: center;
    // height: 12px;
    line-height: 10px;
    align-items: center;
    .dynamic_xinei {
      width: 50%;
      height: 3px;
      background: #009999;
      display: inline-block;
    }
    .dynamic_xi {
      height: 26px;
      width: 2px;
      background: #efefef;
      margin: 0 10px;
    }
  }
  /*.dynamic_title_one:nth-last-child(1){
    i {
      display: none;
    }
  }*/
  // p {
  //   color: #777;
  // }
  .dynamic_xi {
    height: 26px;
    width: 2px;
    background: #efefef;
    margin: 0 10px;
  }
}
.dynamic_box2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 30px;
  text-align: center;
  color: #999;

}
.dynamic_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  .dynamic_box_list {
    border-radius: 10px;
    width: 18%;
    margin-bottom: 25px;
    background: #fff;
    cursor: pointer;
    .dynamic_list_img {
      width: 100%;
      // height: 135px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 10px 10px 0 0;
      }
    }
    .dynamic_list_text {
      height: 200px;
      padding: 0 15px;
      position: relative;
      h4 {
        margin: 10px 0 15px;
        font-size: 15px;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .dynamic_list_mess {
        font-size: 13px;
        height: 88px;
        color: #777;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        // margin-bottom: 28px;
        line-height: 22px;
      }
      .dynamic_more {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        text-align: center;
        p {
          padding: 2px 5px;
          border: 1px solid #009999;
          color: #009999;
          font-size: 13px;
          width: 20%;
        }
      }
      .dynamic_list_bottom {
        font-size: 13px;
        color: #c5c5c5;
        justify-content: space-between;
        position: absolute;
        bottom: 16px;
        p:nth-last-child(2) {
          margin-left: 10px;
        }
        p:nth-last-child(1) {
          margin-left: 10px;
          i {
            margin-right: 5px;
            margin-top: 2px;
          }
        }
      }
    }
  }
  .dynamic_box_list:hover {
    box-shadow: 0px 0px 7px 2px #efefef;
  }
  .new_bottom_empty {
    width: 18%;
    height: 0px;
    visibility: hidden;
  }
}
.dynamic_input {
  width: 1200px;
  margin: 0 auto;
  align-items: center;
  .dynamic_input_one {
    margin-right: 20px;
    align-items: center;
    p {
      color: #888;
      margin-right: 10px;
    }
    /deep/.el-input__inner {
      background: #efefef;
      border-radius: 20px;
      height: 30px;
    }
    /deep/.el-input__prefix,
    .el-input__suffix {
      top: 6px;
    }
    /deep/.el-input__icon {
      line-height: 30px;
    }
  }
  .dynamic_input_two {
    position: relative;
    input {
      border-radius: 20px;
      border: none;
      background: #efefef;
      width: 225px;
      height: 30px;
      padding-left: 17px;
      color: #9a9a9a;
    }
    i {
      position: absolute;
      right: 3%;
      top: 17%;
      color: #9a9a9a;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/park/parkDynamic.vue